"use client"

import { useDomainStore } from "@/stores/use-domain-store"
import {
  DomainFilterOption,
  getAllowedDomainOptions,
  getEnforcedDomainValue,
  shouldShowDomainFilter,
} from "@/utils/admin-domain-filter"
import { useMemo } from "react"

export const useAdminDomainFilter = (allOptionLabel: string) => {
  const { domains, selectedDomain, hasHydrated } = useDomainStore()

  const allowedDomainOptions = useMemo<DomainFilterOption[]>(() => getAllowedDomainOptions(domains), [domains])

  const enforcedDomain = useMemo(() => getEnforcedDomainValue(selectedDomain), [selectedDomain])

  const showDomainFilter = useMemo(
    () => shouldShowDomainFilter(domains, selectedDomain),
    [domains, selectedDomain],
  )

  const domainFilterOptions = useMemo(
    () => [{ value: "", label: allOptionLabel }, ...allowedDomainOptions],
    [allOptionLabel, allowedDomainOptions],
  )

  return {
    domains,
    selectedDomain,
    isDomainStoreReady: hasHydrated,
    allowedDomainOptions,
    domainFilterOptions,
    enforcedDomain,
    showDomainFilter,
  }
}
